<template>
  <div class="p-2 text-center paket-wrapper text-white h-min">
    <p class="mb-2 text-capitalize headline font-weight-bold">Paket Anda</p>
    <p
      class="mb-2 smaller letter-spacing--03"
      v-if="subscribe.punya_paket && subscribe.sisa_kouta != 0"
    >
      ({{ subscribe.sisa_hari }} hari tersisa hingga
      {{ subscribe.habis_berlaku }})
    </p>
    <div v-if="subscribe.is_new && subscribe.sisa_hari <= 30 && subscribe.sisa_kouta >= 10" class="paket-warning px-2 pt-3 pb-3 pt-1 bg-white">
      Masa berlaku paket Anda akan berakhir, silakan klik tombol di bawah ini untuk membeli masa berlaku
      <br>
      <a target="_blank" href="https://api.whatsapp.com/send/?phone=628111137982&text=Hai Izidok, saya ingin menambah masa berlaku. Mohon info terkait harga paket perpanjangan masa berlaku." class="btn btn-primary">Beli Masa Berlaku</a>
    </div>
    <div
      class="px-2 pb-3 pt-1 bg-white text-black paket-inner h-min-inner"
    >
      <b-row class="my-4" v-if="!subscribe.punya_paket || subscribe.sisa_kouta == 0">
        <b-col class="col-12" v-if="!subscribe.punya_paket">
          <h4 style="color: red;" class="font-weight-bold">Tidak Ada Paket Aktif</h4>
          <p>untuk info berlangganan silakan <br> klik lebih lanjut</p>
        </b-col>
        <b-col class="col-12" v-else-if="subscribe.sisa_kouta == 0">
          <h4 style="color: red;" class="font-weight-bold">Paket Anda Habis</h4>
          <p>untuk info berlangganan silakan <br> klik lebih lanjut</p>
        </b-col>
      </b-row>
      <b-row class="my-4" v-else>
        <b-col class="col-6 text-left pr-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Jenis Paket</p>
          <p class="paket-label font-weight-bold">{{ subscribe.nama_paket || '-' }}</p>
        </b-col>
        <b-col class="col-6 text-right pl-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Sisa Visit pasien</p>
          <p class="paket-label font-weight-bold">
            <template v-if="subscribe.punya_paket">
              <template v-if="subscribe.limit_paket == 'Unlimited'">
                <font-awesome-layers class="fa-md mr-4 btn-actions">
                  <font-awesome-icon icon="infinity" />
                </font-awesome-layers>
              </template>
              <template v-else>
                {{ subscribe.sisa_kouta }}
              </template>
            </template>
            <template v-else>-</template>
          </p>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-col class="col-12 mb-3">
          <hr class="m-2" style="border-top: 2px solid #c0c4cc;">
        </b-col>
        <b-col class="col-6 text-left pr-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Jenis Add On</p>
          <p class="paket-label font-weight-bold mb-2">WhatsApp</p>
          <p class="paket-label font-weight-bold">SMS</p>
        </b-col>
        <b-col class="col-6 text-right pl-0">
          <p style="color: #58a7e2;" class="paket-label font-weight-bold mb-2">Sisa Add On</p>
          <p class="paket-label font-weight-bold mb-2">{{ addonWA.sisa || '-' }}</p>
          <p class="paket-label font-weight-bold">{{ addonSMS.sisa || '-' }}</p>
        </b-col>
      </b-row>
      <template>
        <b-button
          v-if="subscribe.punya_paket && subscribe.sisa_kouta !== 0"
          class="text-capitalize btn-sm px-5 btn-more"
          @click="showInfo"
          style="border-radius: 10px;"
          >Lebih lanjut</b-button
        >
        <b-button
          v-else
          class="text-capitalize btn-sm px-5 btn-more"
          @click="checkReminder"
          style="border-radius: 10px;"
          >Lebih lanjut</b-button
        >
      </template>
    </div>

    <b-modal
      ref="__modal-info"
      hide-footer
      hide-header
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none"
    >
      <div class="row px-5">
        <div class="col-12 mb-3">
          <h6 class="font-weight-bold">Informasi Paket</h6>
        </div>
        <div class="col-md-6">
          <p class="info-label">Kuota tersisa</p>
          <p class="info-label">Paket</p>
          <p class="info-label">Tanggal mulai paket</p>
          <p class="info-label">Tanggal berakhir paket</p>
        </div>
        <div class="col-md-6">
          <p class="info-label">
            : 
            <template v-if="subscribe.punya_paket">
              <template v-if="subscribe.limit_paket == 'Unlimited'">
                <font-awesome-layers class="fa-md mr-4 btn-actions">
                  <font-awesome-icon icon="infinity" />
                </font-awesome-layers>
              </template>
              <template v-else>
                {{ subscribe.sisa_kouta || '-' }}
              </template>
            </template>
          </p>
          <p class="info-label">: {{ subscribe.nama_paket || '-' }}</p>
          <p class="info-label">: {{ subscribe.tanggal_mulai || '-' }}</p>
          <p class="info-label">: {{ subscribe.habis_berlaku || '-' }}</p>
        </div>
        <div class="col-12 mb-3">
          <hr style="border-top: 2px solid #c0c4cc;">
        </div>
        <div class="col-12 mb-3">
          <h6 class="font-weight-bold">Informasi Add On</h6>
        </div>
        <div class="col-md-6">
          <p class="info-label">Jenis Add On</p>
          <p class="info-label">Sisa Add On</p>
          <p class="info-label">Tanggal pembelian</p>
        </div>
        <div class="col-md-6">
          <p class="info-label">: WhatsApp</p>
          <p class="info-label">: {{ addonWA.sisa || '-' }}</p>
          <p class="info-label">: {{ addonWA.pay_date ? formatDate(addonWA.pay_date) : '-' }}</p>
        </div>
        <div class="col-12 mb-3">
          <hr style="border-top: 2px solid #c0c4cc;">
        </div>
        <div class="col-md-6">
          <p class="info-label">Jenis Add On</p>
          <p class="info-label">Sisa Add On</p>
          <p class="info-label">Tanggal pembelian</p>
        </div>
        <div class="col-md-6">
          <p class="info-label">: SMS</p>
          <p class="info-label">: {{ addonSMS.sisa || '-' }}</p>
          <p class="info-label">: {{ addonSMS.pay_date ? formatDate(addonSMS.pay_date) : '-' }}</p>
        </div>
        <div class="col-md-2 offset-10">
          <b-button
            class="btn-sm px-4"
            @click="hideInfo"
            variant="primary"
          >OK</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="__modal-reminder"
      size="lg"
      hide-footer
      hide-header
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none"
      @hidden="resetHeader"
    >
      <div class="row">
        <div class="col-md-12 px-5 py-3">
          <h5 class="font-weight-bold">
            Paket Berlangganan Anda telah habis! GRATIS 2000 kuota rekam medis
            (Paket {{ subscribe.nama_paket }}) akan otomatis diberikan pada
            {{ nextPaketDate(subscribe.habis_berlaku) }}.
          </h5>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio
              v-model="selected"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="0"
            >
              <h5 class="font-weight-bold">
                Tunggu hingga Paket {{ subscribe.nama_paket }} aktif
              </h5></b-form-radio
            >
            <b-form-radio
              v-model="selected"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="1"
            >
              <h5 class="font-weight-bold">
                Beli kuota rekam medis & perpanjang paket sekarang
              </h5></b-form-radio
            >
          </b-form-group>
        </div>
        <div class="col-md-2 offset-10">
          <b-button
            @click="actionReminder"
            :disabled="selected == null"
            variant="primary"
            class="btn-sm px-2"
            >OK</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faInfinity);
import moment from "moment";
moment.locale("id");

export default {
  data() {
    return {
      selected: null,
      reminder: null,
      addonWA: {
        sisa: null
      },
      addonSMS: {
        sisa: null
      },
    };
  },
  components: {
    FontAwesomeLayers
  },
  props: ["subscribe"],
  computed: {
    ...mapGetters({
      getKlinikId: "getKlinikId"
    })
  },
  mounted() {
    this.fetchUser();
    this.reminder = localStorage.getItem("REMINDER");
  },
  methods: {
    async fetchUser() {
      const res = await this.$axios.get(`user/${this.$store.state.user.id}?klinik_id=${this.getKlinikId}`);
      const { status, addons } = res.data;
      if (status) {
        this.addonWA = addons.filter(t => t.tipe === 'whatsapp')[0] || null;
        this.addonSMS = addons.filter(t => t.tipe === 'sms')[0] || null;
      };
    },
    formatDate(date) {
      return moment(date).format('DD MMMM YYYY');
    },
    showInfo() {
      this.$router.push('/klinik/subskripsi');
      return true;
      // this.$refs["__modal-info"].show();
    },
    hideInfo() {
      this.$refs["__modal-info"].hide();
    },
    showReminder() {
      this.$refs["__modal-reminder"].show();
      document
        .getElementsByClassName("app-header")[0]
        .style.setProperty("z-index", 1041);
    },
    nextPaketDate(val) {
      return val;
    },
    resetHeader() {
      localStorage.removeItem("REMINDER");
      document
        .getElementsByClassName("app-header")[0]
        .style.setProperty("z-index", 88);
    },
    async checkReminder() {
      this.$router.push('/klinik/subskripsi');
      return true;
    },
    async actionReminder() {
      try {
        const res = await this.$axios.post(
          `klinik/subscribe/confirmation`,
          {
            klinik_id: this.getKlinikId,
            extend: this.selected,
            notification: 0
          }
        );
        const { status, data, message } = res.data;
        this.$refs["__modal-reminder"].hide();
        if (status) {
          this.notif({
            ...data,
            extend: this.selected
          });
        } else {
          this.$swal({
            title: "Oops...",
            text: message || "Something went wrong!",
            type: "error",
            allowOutsideClick: false,
            confirmButtonText: "OK"
          });
        }
      } catch (err) {
        this.$swal({
          title: "Oops...",
          text: "Something went wrong!",
          type: "error",
          allowOutsideClick: false,
          confirmButtonText: "OK"
        });
      }
    },
    notif(data) {
      let html = ``;
      if (data.extend == "0")
        html = `<p class="font-weight-bold">Terima kasih. Silakan tunggu hingga Paket ${
          this.subscribe.nama_paket
        } Anda aktif pada ${
          data.start_date
        }. Jika Anda memiliki pertanyaan silakan hub ${data.marketing_email ||
          "marketing@izidok.id"} atau ${data.marketing_phone ||
          "0878-8081-0414"}. Dan call center 24 jam di ${data.call_center ||
          "021-7237982"}</p>`;
      else if (data.extend == "1")
        html = `<p class="font-weight-bold">Request perpanjangan paket izidok klinik diterima. Mohon tunggu hingga tim kami menghubungi Anda. Jika Anda memiliki pertanyaan silakan hub ${data.marketing_email ||
          "marketing@izidok.id"} atau ${data.marketing_phone ||
          "0878-8081-0414"}. Dan call center 24 jam di ${data.call_center ||
          "021-7237982"}</p>`;

      this.$swal({
        html: html,
        type: "success",
        allowOutsideClick: false,
        confirmButtonText: "OK"
      });
    }
  }
};
</script>

<style lang="scss">
.modal-backdrop {
  opacity: 0.5 !important;
}
</style>

<style lang="scss" scoped>
.h-min {
  min-height: 405px;
}

.h-min-inner {
  min-height: 325px;
}

.paket-wrapper {
  background-color: #789dc3;
  border-radius: 10px;

  .smaller {
    font-size: 75%;
  }

  .letter-spacing {
    &--03 {
      letter-spacing: -0.3px;
    }
  }

  .headline {
    font-size: 1.6rem;
    color: #e2ecf6;
    letter-spacing: -0.2px;
  }

  .paket-inner {
    border-radius: 8px;
    color: #4a7fa4;

    .tipe-paket {
      color: #58a7e2;
      font-size: 1.7rem;
    }

    .highlight-text {
      font-size: 5rem;
      line-height: 5.4rem;

      &.--with-spacing {
        letter-spacing: 12px;
        margin-left: calc(50vh - 100%);
      }
    }

    .text-red {
      color: red;
    }
  }
}

.paket-label {
  font-size: 0.8em;
}

.info-label {
  font-size: 0.8em;
  font-weight: bold;
}

.btn-more {
  color: #fff !important;
  background-color: #329ac5 !important;
  border-color: #329ac5 !important;
}

.btn-more:hover {
  color: #fff;
  background-color: #329ac5;
  border-color: #329ac5;
}

@media only screen and (max-width: 1400px) and (min-width: 1250px) {
  .h-min {
    min-height: 405px;
  }

  .h-min-inner {
    min-height: 315px;
  }

  .paket-label {
    font-size: 1em;
  }
}

@media only screen and (min-width: 1410px) {
  .paket-label {
    font-size: 1.1em;
  }
}

.paket-warning {
  margin-bottom: 10px;
  border-radius: 8px;
  color: #4a7fa4;
}
</style>
